import { AuthorizedEmployeeCardHrmTypeModel } from '../model/authorized-employee-card-hrm-type-model';
import { AuthorizedEmployeeCardModel } from '../model/authorized-employee-card-model';

export class PerEmployeeCardAuthorityModel {
    canEdit: boolean = false;
    canView: boolean = false;

    // card için admin yetkisi var mı. IK adminler için
    isAdmin: boolean = false;

    // card onay yetkilisi mi? bu yetkiye sahipse onaylı kayıtlara müdahale edebilir.
    isApproveAdmin: boolean = false;

    isVisibleForEmployee: boolean;

    // yönetici olanın viewChild'ı işaretli ise bu alan true olur.
    // satır bazlı yetki ile kullanıcının hrmType yetkisi kısıntlandığında çakışma olduğu için kullanılır.
    // hrmTypeLimitations değeri dolu ise yarar
    canViewAllHrmTypes: boolean;

    hrmTypeLimitations: AuthorizedEmployeeCardHrmTypeModel[];

    employeeCardAuthority: AuthorizedEmployeeCardModel

    public get hasAnyAuthority(): boolean {
        return this.isVisibleForEmployee && (this.canEdit || this.canView);
    }

    public get hasHrmTypeLimitations(): boolean {
        return this.hrmTypeLimitations && this.hrmTypeLimitations.length > 0;
    }

    constructor(
        canEdit: boolean,
        canView: boolean,
        isAdmin: boolean,
        isApproveAdmin: boolean,
        isVisibleForEmployee: boolean,
        canViewAllHrmTypes: boolean,
        hrmTypeLimitations: AuthorizedEmployeeCardHrmTypeModel[],
        employeeCardAuthority: AuthorizedEmployeeCardModel
    ) {
        this.canEdit = canEdit;
        this.canView = canView;
        this.isAdmin = isAdmin;
        this.isVisibleForEmployee = isVisibleForEmployee;
        this.isApproveAdmin = isApproveAdmin;
        this.hrmTypeLimitations = hrmTypeLimitations;
        this.canViewAllHrmTypes = canViewAllHrmTypes;
        this.employeeCardAuthority = employeeCardAuthority;
    }
}
